<template>
  <div class='h-dialogContainer'>
    <div class='row h-row-inputBox'>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.eventLevel')}}:</div>
        <ejs-textbox :readonly='true' :value='this.levelFormat(eventData.eventLevel)'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.eventType')}}:</div>
        <ejs-textbox :readonly='true' :value='this.typeFormat(eventData.eventType)'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.neType')}}:</div>
        <ejs-textbox :readonly='true' :value='eventData.neType'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.neName')}}:</div>
        <ejs-textbox :readonly='true' :value='eventData.neName'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.brdType')}}:</div>
        <ejs-textbox :readonly='true' :value='eventData.brdTypeDes'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.eventSource')}}:</div>
        <ejs-textbox :readonly='true' :value='eventData.neEventFDN'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.createTime')}}:</div>
        <ejs-datepicker :format='dateFormat' :readonly='true' :value='eventData.createTimeFormat'></ejs-datepicker>
      </div>
    </div>
    <div class='row h-row-inputBox'>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.eventDes')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.eventName'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.additionInfo')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.eventComment'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.extraInfo')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.appendInfo'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxdwinfo1')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxdwinfo1'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxdwinfo2')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxdwinfo2'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxkzinfo1')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxkzinfo1'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxkzinfo2')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxkzinfo2'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxkzinfo3')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxkzinfo3'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.xxkzinfo4')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.xxkzinfo4'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.eventCause')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.cause'></ejs-textbox>
      </div>
      <div class='col-sm-6 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.advise')}}:</div>
        <ejs-textbox multiline='true' :readonly='true' :value='eventData.advise'></ejs-textbox>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'eventDetail',
  data() {
    return {
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      eventData: {}
    };
  },
  methods: {
    setData(args) {
      this.eventData = args;
    },
    levelFormat(data) {
      return this.$t(`Alarm.alarmLevel_${data}`);
    },
    typeFormat(data) {
      return this.$t(`Alarm.alarmType_${data}`);
    }
  }
};
</script>